<template>
    <div class="mt-5">
        <h2>Opplevelsesprodukter</h2>
        <br>
        <div class="container text-justify">
            <h4>Kunde og mottaker</h4>
            <p>
                Hos YouWish skiller vi mellom den som kjøper og den som mottar en gave. Vi selger gaver til
                “gavekjøpere” som gir disse til “gavemottakere”. Siden kjøpere sjeldent vet akkurat hva mottaker liker
                eller ønsker seg, lager vi konsepter av aktiviteter som er skreddersydde etter kjøpers behov.
            </p>
            <p>
                Slik YouWish sine opplevelsesprodukter er satt opp er for å selge til Gavekjøper. Gavemottaker leser
                sjeldent, om “aldri”, på produktet, men får informasjon om opplevelsen og betingelser for gjennomføring
                når de skal booke opplevelsen på youwish.no/book.
            </p>
            <br>

            <h4>Opplevelser</h4>
            <p>
                Det som gjør YouWish unikt er at vi selger unike opplevelser. Kunden vet ikke helt hva de har lyst på og
                ser ikke etter en spesiell tilbyder, men ønsker å kunne gi bort en unik opplevelse.
            </p>
            <p>
                Vi lager konseptbaserte opplevelser som er tilpasset gavemarkedet og skreddersydde etter våre kunders
                behov. Gavekjøper tar valget for mottaker og velger en spesifikk opplevelse, for eksempel Ølsmaking for
                to, Spapakke klassisk eller Fjordcruise for to.
            </p>
            <p>
                Vi tar aktiviteten, kurset eller produktet som partneren tilbyr og lager et gavekonsept av det. I
                YouWish kaller vi dette for konseptbaserte opplevelser.
            </p>
            <p>Eksempel:</p>
            <b-table :items="items"></b-table>
            <br>

            <h4>Opplevelsesgavekort</h4>
            <p>
                Gavekjøper velger et beløp og gir valget til mottaker som selv velger en spesifikk opplevelse på
                YouWish.no. Ett gavekort, hvor mottaker velger fritt blant alle opplevelser på YouWish.no. For eksempel
                Vinsmaking, Spaweekend for to eller Skytedate.
            </p>
            <br>

            <h4>Temagavekort</h4>
            <p>
                Ligner på Opplevelsesgavekortet i den forstand at gavekjøper velger summen og gir valget til mottaker
                som selv velger opplevelsen. Forskjellen er at Temagavekort viser frem utvalget til en spesifikk
                kategori. For eksempel “Unike overnattinger”, hvor mottaker velger mellom Natt i tretopphytte, Romantikk
                på slottet, Arctic Dome osv.
            </p>

            <p>
                YouWish skriver artikler om sine samarbeidspartnere på vår inspirasjon-/bloggside. Dette er kostnadsfritt og det eneste kriteriet er dere som samarbeidspartnere linker fra siden deres til artikkelen.
                Artikler blir delt i nyhetsbrev og sosiale medier der vi fremmer samarbeidspartnere og opplevelsene deres.
            </p>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            items: [
                {
                    produkt: 'To netter på dobbeltrom med tilgang til spa til konseptet',
                    opplevelse: 'Romantisk spaweekend'
                },
                {produkt: 'Skyt 50 skudd med grovkalibret revolver til konseptet', opplevelse: 'Skytedate'},
                {produkt: 'Entre avgift til frokostbuffén på et hotell', opplevelse: 'Hotellfrokost for to'},
            ]
        }
    }
}
</script>

